module.exports = __webpack_public_path__ + "static/img/img-background-4-croped22.34dfbc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/carousel_background/img-background-4-croped22.png
// module id = PjWn
// module chunks = 36